document.addEventListener('DOMContentLoaded', function() {
    const breadcrumbs = document.querySelector('#breadcrumbs');
    if (!breadcrumbs) return;

    const next = breadcrumbs.nextElementSibling;
    if (!next) return;

    breadcrumbs.classList.toggle('breadcrumbs-light', isSectionDark(next));
});

// Recursively determines if the visible background behind breadcrumbs is dark.
// For unknown wrapper elements (main, article, etc.) it recurses into the first child.
function isSectionDark(el) {
    // Columns block: check the block's own background first, then the visually-left column
    if (el.classList.contains('wp-block-columns')) {
        if (hasDarkSolidBackground(el)) return true;
        const isReversed = el.classList.contains('reverse');
        const side = isReversed ? 'last' : 'first';
        const leftCol = el.querySelector(`.wp-block-column:${side}-child`);
        return leftCol ? isColumnDark(leftCol) : false;
    }
    // Multiblock: check its own background directly
    if (el.classList.contains('wp-block-create-block-tankbar-multiblock')) {
        return isElementDark(el);
    }
    // Any other wrapper (main, wp-block-group, inner-container, etc.): recurse into first child
    const firstChild = el.querySelector(':scope > *:first-child');
    return firstChild ? isSectionDark(firstChild) : isElementDark(el);
}

function isColumnDark(column) {
    // Gallery in multiblock = dark visual background
    if (column.querySelector(':scope > .wp-block-create-block-tankbar-multiblock > .multiblock-bg > .multiblock-gallery')) {
        return true;
    }
    // Check background-color on multiblock or column (skip backgroundImage — may be decorative texture)
    const multiblock = column.querySelector(':scope > .wp-block-create-block-tankbar-multiblock');
    for (const el of [multiblock, column].filter(Boolean)) {
        if (hasDarkSolidBackground(el)) return true;
    }
    return false;
}

function hasDarkSolidBackground(el) {
    const bg = getComputedStyle(el).backgroundColor;
    const m = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (!m) return false;
    const alpha = m[4] !== undefined ? parseFloat(m[4]) : 1;
    if (alpha === 0) return false; // fully transparent — not dark
    const luminance = (0.299 * m[1] + 0.587 * m[2] + 0.114 * m[3]) / 255;
    return luminance < 0.5;
}

function isElementDark(el) {
    const style = getComputedStyle(el);
    if (style.backgroundImage !== 'none') return true;
    const rgb = style.backgroundColor.match(/\d+/g);
    if (rgb && rgb.length >= 3) {
        const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
        if (luminance < 0.5) return true;
    }
    if (el.querySelector(':scope > .multiblock-bg > .multiblock-gallery')) return true;
    return false;
}
//# sourceMappingURL=breadcrumbs.js.map
